import React, {Component} from 'react';
import '../css/TransactionHistory.css';
import { withTranslation } from 'react-i18next';
import * as CurrencyFormat from 'react-currency-format';
import { Table } from 'react-bootstrap';
class TransactionsSummary extends Component{
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            transactionsArray: []
        }
    }

    static getDerivedStateFromProps(props, state) {
        let transactionsArray = [];
        props.transactions && props.transactions.map(transaction => transactionsArray.push(transaction));

        return {
            transactionsArray: transactionsArray
        }
    }

    render(){
        const {t} = this.props
        return(
            <div 
            // style={{marginLeft: "12px" }}
            >{
                this.props.isTransactionsEmpty ? <div className="tabMessage">There are no transactions for chosen period</div> :
                !this.state.transactionsArray || this.state.transactionsArray.length === 0 ? <div className="tabMessage">{t('fetching')+" "+t('transaction')}s</div> :
                    // this.state.transactionsArray.length === 0 ? <div className="tabMessage">{t('no')+" "+t('transaction')}s</div> :
                    <Table responsive id="FundDetailsTab" style={{marginLeft: "-1px", marginRight: "1px"}} 
                        className="transactions">
                        <thead>
                            <th style={{height: 20}}>{t('transactions:date')}</th>
                            <th style={{height: 20}}>{t('transactions:transactionDetails')+" "+t('transactions:allAccounts')}</th>
                            <th style={{height: 20}}>{t('transactions:debits')}</th>
                            <th style={{height: 20}}>{t('transactions:credits')}</th>
                            <th style={{height: 20}}>{t('transactions:balance')}</th>
                        </thead>
                        <tbody>
                            {
                               this.state.transactionsArray.map(transaction => 
                                !transaction.details ? "" : transaction.details.map((detail, detailIndex) => 
                                <tr style={{lineHeight: 1}} key={detailIndex}>
                                    <td style={{fontWeight: 
                                            transaction.transactionType==="opening" || transaction.transactionType==="closing" ?
                                            "bold" : "normal"}}>{detailIndex === 0 && transaction.date}</td>
                                    <td style={{fontWeight: 
                                            transaction.transactionType==="opening" || transaction.transactionType==="closing" ?
                                            "bold" : "normal"}}>{detail.description}</td>
                                    <td style={{textAlign: "right", fontWeight: 
                                            transaction.transactionType==="opening" || transaction.transactionType==="closing" ?
                                            "bold" : "normal"}}>{detail.debits ? detail.debits !== null ? 
                                            <CurrencyFormat value={Number(detail.debits).toFixed(2)} 
                                                displayType={'text'}
                                                thousandSeparator={true}
                                                prefix={'$'}/> : "" : ""}</td>
                                    <td style={{textAlign: "right", fontWeight: 
                                            transaction.transactionType==="opening" || transaction.transactionType==="closing" ?
                                            "bold" : "normal"}}>{detail.credits ? detail.credits !== null ? 
                                            <CurrencyFormat value={Number(detail.credits).toFixed(2)}
                                                displayType={'text'} 
                                                thousandSeparator={true}
                                                prefix={'$'} /> : "" : ""}</td>
                                    <td style={{textAlign: "right", fontWeight: 
                                            transaction.transactionType==="opening" || transaction.transactionType==="closing" ?
                                            "bold" : "normal"}}>{detail.balance ? detail.balance !== null ? 
                                                <CurrencyFormat value={Number(detail.balance).toFixed(2)}
                                                displayType={'text'} 
                                                thousandSeparator={true}
                                                prefix={'$'} /> : "" : ""}</td>
                                </tr>))
                            }
                        </tbody>
                    </Table>
                }
            </div>
        )
    }
}

export default withTranslation()(TransactionsSummary);